import React,{ useState, useEffect } from 'react';
import Image from 'react-bootstrap/Image'
import Markdown from 'markdown-to-jsx';

//includes
import '../../assets/css/default.min.css';
import '../../assets/css/about.min.css';
//Components
import HeaderLight from '../../components/headerComponent/HeaderLight';
import FooterLight from '../../components/footerComponent/footerLight';



function About() {
    const file_name = 'about.md';
	const [post, setPost] = useState('');

	useEffect(() => {
		import(`../../markdown/${file_name}`)
			.then(res => {
				fetch(res.default)
					.then(res => res.text())
					.then(res => setPost(res));
			})
			.catch(err => console.log(err));
	});
  
    return (
        <div className="aboutPage light">
            <HeaderLight/> 
         
           <div className="container">
        
                <div className="row">
                    <div className="col-sm-2" style={{backgroundColor:"transparent"}}></div>
                    <div className="col-sm-8"style={{backgroundColor:"white"}}>
                  
                            <h4 className='text-muted'> </h4>
                            <a href="#physics"> <h1 className="display-3">
                              About Auro</h1></a>
                            
                            <p className="h6">
                               
                               
                                <br></br>
                               
                            <Markdown options={{ wrapper: 'article' }}>{post}</Markdown>;
                          
                            Recently, I worked in a voluntary internship for a month in Soft Matter Physics in School of Physics and Astrononmy in University of Edinburgh. 
                            The project revolved around finding a reliable method for particle sizing in Multi-modal suspensions.
                            <hr></hr>
                            <a href="#physics"> Read More ></a>
                            </p>

                    </div>
                    <div className="col-sm-2" style={{backgroundColor:"transparent"}}></div>
                </div>

           </div>
            <FooterLight/>
        </div>
    )
}

export default About
